export default __webpack_public_path__ + "static/media/WRS.3284cc38.exe";